
import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import '../styles/pages.css'; 
import { useTranslation } from 'react-i18next';
import UploadTerritoriesMultilanguage from '../services/bulk_upload_and_related/UploadTerritoriesMultilanguage';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UtilsLocalizedExcelString from '../services/utilsLocalizedExcelString.jsx';


function AboutPage(props) {

    const { t } = useTranslation();
    const [excelLoadedSheet, setExcelLoadedSheet] = useState(false);
    const [excelDataSheet, setExcelDataSheet]= useState("");


    





    useEffect(() => {
 const handleFetchFromUrl = async () => {
    if(!excelLoadedSheet) {
    try {
      const url = "https://storage.googleapis.com/fgr-data-visualisation-assets/fgr_silvagris_assets.xlsx";
      const response = await axios.get(url, { responseType: 'arraybuffer' });

      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[1];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setExcelDataSheet(jsonData);
      setExcelLoadedSheet(true);
    } catch (error) {
    
      console.error('Error fetching or parsing Excel file:', error);
    }
  }
  };
  
  
    handleFetchFromUrl();

  }, [props.lang, excelLoadedSheet]);
    return (
      <React.Fragment >
        {/* < UploadTerritoriesMultilanguage /> */}
        <div className="App">
          {excelDataSheet !== "" &&
          <>
         {props.argument === "background" ?
         <div style={{marginTop: "2rem"}}>
        <h5 className="title-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[1])}</h5>
        <p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[2])}</p>
      <p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[3])}</p>
      <p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[4])}</p>
      <p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[5])}</p>
      
            </div> : <div style={{marginTop: "2rem"}}>
      <h5 className="title-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[6])}</h5>
     <p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[7])}</p>
     <p className="paragraph-body">{UtilsLocalizedExcelString(props.lang, excelDataSheet[8])}</p>
     <br/>
     <br/>
     

<br/>
    {/* <div className="wrapper"> */}
     <Table  borderless 
      style ={{ borderSpacing: "0",
        borderCollapse: "collapse",
      //borderStyle: "hidden", 
      marginBottom: "0px",  
      borderBottom:"0px solid trasparent !important", 
      orderBottomWidth: "0"}} >
   
      <tbody>
        <tr><td colSpan={3}  >
          <br></br>
          <hr style={{marginLeft: "0.7rem", marginRight: "0.7rem", maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
            }}></hr>
          <h5 style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}} className="title-body">{t('global_action_plan_title1')}</h5>
            <br></br>
          </td>
           
        </tr>
        <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2", 
          //borderLeft:"0.5px solid rgb(187, 186, 186)" 
        }}><p style={{marginTop: "1rem", 
            marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[29])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[30])}</span></p>
            </td>

            <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
            className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[31])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[32])}</span></p>
            </td>

            <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
            className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[33])} </span>
            <span className="table-grey-column-non-bold-text"> {UtilsLocalizedExcelString(props.lang, excelDataSheet[34])}</span></p>
            </td>
        </tr>

        <tr  className="wrapper-side-borders" >
        <td style={{backgroundColor:"#F2F2F2" }}></td>

        <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[35])} </span>
        <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[36])}</span></p>
        </td>
        
        <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[37])} </span>
        <span className="table-grey-column-non-bold-text"> {UtilsLocalizedExcelString(props.lang, excelDataSheet[38])}</span></p>
        </td>
        </tr>

        <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2"}}>
            <p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[39])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[40])}</span></p>
            </td>

          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[41])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[42])}</span></p>
         </td>

          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[45])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[46])}</span></p>
          </td>
        
        </tr>
        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>

          <td> <p style={{paddingTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
              <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[43])} </span>
              <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[44])}</span></p>
          </td>

          <td><p style={{paddingTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[47])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[48])}</span></p>
          </td>
        </tr>

        <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2"}}>
            <p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[49])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[50])}</span></p>
          </td>

          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[51])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[52])}</span></p>
          </td>
         
        

          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[57])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[58])}</span>
          </p>
          </td>
          
         


        </tr>
        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td> <p style={{marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[53])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[54])}</span></p>
          </td>

          <td><p style={{paddingTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[59])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[60])}</span></p>
            </td>
        </tr>

        <tr className="wrapper-side-borders">
        <td style={{backgroundColor:"#F2F2F2" }}></td>
        <td><p style={{marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[55])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[56])}</span></p>
          </td>
          <td><p style={{paddingTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
          className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[61])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[62])}</span></p>
          </td>
         
        </tr>
        <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2"}}>
            <p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[63])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[64])}</span></p></td>

          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[65])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[66])}</span></p>
            </td>
        
          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[71])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[72])}</span></p>
            </td>
         
        
        </tr>
        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2"}}>
           </td>

          <td><p style={{marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[67])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[68])}</span></p>
            </td>
        
          <td><p style={{marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[73])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[74])}</span></p>
            </td>
         
        
        </tr>
        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2"}}></td>

          <td><p style={{marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[69])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[70])}</span></p>
            </td>
        
          <td><p style={{marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[75])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[76])}</span></p>
            </td>
         
        
        </tr>
         <tr style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}><td colSpan={3} >
          <br></br>
          <hr style={{marginLeft: "0.7rem", marginRight: "0.7rem", maxWidth: "50px" , border:"0",height:"2px",background:"#116bac", opacity: "1",
            }}></hr>
          <h5 style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}} className="title-body">{t('global_action_plan_title2')}</h5>
            <br></br>
          </td>
           
        </tr>
         <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2" }}><p 
          style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[77])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[78])}</span></p>
            </td>

            <td><p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
              <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[79])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[80])}</span></p>
            </td>

            <td><p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
            className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[83])} </span>
            <span className="table-grey-column-non-bold-text"> {UtilsLocalizedExcelString(props.lang, excelDataSheet[84])}</span></p>
            </td>
        </tr>

        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
            <td><p style={{marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
            className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[81])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[82])}</span></p></td>

            <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
            className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[85])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[86])}</span></p>
            </td>
        </tr>

        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
            <td></td>

            <td><p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
            className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[87])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[88])}</span></p>
            </td>
        </tr>



        <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2"}}>
            <p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[89])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[90])}</span></p>
            </td>

          <td><p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[91])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[92])}</span></p>
         </td>

          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[93])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[94])}</span></p>
          </td>
        </tr>


        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2"}}></td>
          <td></td>

          <td><p style={{ marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[95])} </span>
            <span className="table-grey-column-non-bold-text"> {UtilsLocalizedExcelString(props.lang, excelDataSheet[96])}</span></p>
          </td>
        </tr>


        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2"}}></td>
          <td></td>

          <td><p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[97])} </span>
            <span className="table-grey-column-non-bold-text"> {UtilsLocalizedExcelString(props.lang, excelDataSheet[98])}</span></p>
          </td>
        </tr>


        <tr className="wrapper-side-borders">
        <td style={{backgroundColor:"#F2F2F2" }}></td>

        <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[99])} </span>
        <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[100])}</span></p>
        </td>
        
        <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[101])} </span>
        <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[102])}</span></p>
        </td>
        </tr>





        <tr className="wrapper-side-borders">
        <td style={{backgroundColor:"#F2F2F2" }}></td>
        <td></td>
    
        <td><p style={{ marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[103])} </span>
        <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[104])}</span></p>
        </td>
        </tr>

        <tr className="wrapper-side-borders" >
        <td style={{backgroundColor:"#F2F2F2" }}></td>

        <td></td>
        
        <td><p style={{ marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[105])} </span>
        <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[106])}</span></p>
        </td>
        </tr>

        <tr className="wrapper-side-borders">
        <td style={{backgroundColor:"#F2F2F2" }}></td>

        <td></td>
        
        <td><p style={{ marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[107])} </span>
        <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[108])}</span></p>
        </td>
        </tr>



        <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
        <td style={{backgroundColor:"#F2F2F2"}}>
            <p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[109])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[110])}</span></p>
            </td>

          <td> <p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
              <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[111])} </span>
              <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[112])}</span></p>
          </td>

          <td><p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[127])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[128])}</span></p>
          </td>
        </tr>


        <tr className="wrapper-side-borders">
        <td style={{backgroundColor:"#F2F2F2" }}></td>

        <td></td>
        
        <td><p style={{ marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
        className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[115])} </span>
        <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[116])}</span></p>
        </td>
        </tr>

        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td> <p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[117])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[118])}</span></p>
          </td>

          <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[119])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[120])}</span></p>
            </td>
        </tr>

        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td>  </td>

          <td><p style={{  marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[121])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[122])}</span></p>
            </td>
        </tr>

        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td>  </td>

          <td><p style={{ marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[123])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[124])}</span></p>
            </td>
        </tr>



        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td> <p style={{ marginTop: "3rem",marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[125])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[126])}</span></p>
          </td>

          <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[127])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[128])}</span></p>
            </td>
        </tr>





        <tr className="wrapper-side-borders" style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2"}}>
            <p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[129])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[130])}</span></p>
          </td>

          <td><p style={{marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[131])} </span>
          <span className="table-grey-column-non-bold-text"> {UtilsLocalizedExcelString(props.lang, excelDataSheet[132])}</span></p>
          </td>
        
          <td><p style={{ marginTop: "1rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[133])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[134])}</span>
          </p>
          </td>
        </tr>


        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td>  </td>

          <td><p style={{marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[135])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[136])}</span></p>
            </td>
        </tr>


        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td>  </td>

          <td><p style={{ marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[137])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[138])}</span></p>
            </td>
        </tr>

        <tr className="wrapper-side-borders">
          <td style={{backgroundColor:"#F2F2F2" }}></td>
          <td> <p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[139])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[140])}</span></p>
          </td>

          <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[141])} </span>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[142])}</span></p>
            </td>
        </tr>

        <tr className="wrapper-side-borders" style={{ borderBottom: "0.5px solid rgb(187, 186, 186)"}}>
        <td style={{backgroundColor:"#F2F2F2" }}></td>
        <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}>
          <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[143])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[144])}</span></p>
          </td>
          <td><p style={{ marginTop: "3rem", marginLeft: "0.7rem", marginRight: "0.7rem"}}><span 
          className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[145])} </span>
          <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[146])}</span></p>
          </td>
         
        </tr>
      </tbody>
    </Table>
    
    {/* </div> */}

  </div>}</>}
  </div>
      </React.Fragment>
    );
  }

  export default AboutPage;